import { Component } from "react";
import withAuth from "../../../components/withAuth";
import { withStyles } from "@mui/styles";
import { compose } from "redux";
import { connect } from "react-redux";
import SignatureCard from "../../../components/AnalyseRisques/SignatureCard";

const styles = (theme) => ({
    row: {
        "&:nth-of-type(odd)": {
            backgroundColor: theme.palette.background.default,
        },
    },
});

class AnalyseRisquesSignatures extends Component {
    constructor(props) {
        super(props);

        let companies;

        if (this.props.sppTab) companies = props.analyseRisques.sppCompanies;
        else companies = props.analyseRisques.raCompanies;

        this.state = {
            signatories: companies.filter((s) => s.concerned),
        };
    }

    componentDidMount() {
        this.updateSignatories(this.props);
    }

    updateSignatories(props) {
        let companies;
        if (props.sppTab) companies = props.analyseRisques.sppCompanies;
        else companies = props.analyseRisques.raCompanies;

        let signatories = companies.filter((c) => c.concerned);
        /*.slice(0, 2);

        for (let i = 0; i < companies.length; i++) {
            props.risks.forEach((r) => {
                r.solutions.forEach((s) => {
                    let concernedCompanyNotFoundYet = s.concernedCompanies.find(cc => cc.company.id === companies[i].id
                        && !signatories.find((signatory) => signatory.id === cc.company.id))

                    if(concernedCompanyNotFoundYet && concernedCompanyNotFoundYet.concerned){
                        signatories.push(companies[i]);
                    }
                })
            })
        }*/

        this.setState({
            signatories,
        });
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        let modifiedState = prevState;
        let companies;
        if (nextProps.sppTab) companies = nextProps.analyseRisques.sppCompanies;
        else companies = nextProps.analyseRisques.raCompanies;

        let signatories = companies.filter((c) => c.concerned);

        modifiedState.signatories = signatories;

        return modifiedState;
    }

    render() {
        let signatures = [];

        this.state.signatories.forEach((c, index) =>
            signatures.push(
                <SignatureCard
                    key={(this.props.sppTab ? "spp-" : "ra-") + index}
                    index={(this.props.sppTab ? "spp-" : "ra-") + index}
                    sppTab={this.props.sppTab}
                    currentCompany={c}
                />
            )
        );

        return <div className="col-lg-12 col-md-12 col-sm-12 col-12 row without-side-padding">{signatures}</div>;
    }
}

const mapStateToProps = (state) => {
    return {
        risks: state.analyseRisques.risks,
        analyseRisques: state.analyseRisques,
        analysesRisques: state.analysesRisques,
    };
};

const mapDispatchToProps = () => {
    return {};
};

export default compose(
    withAuth,
    withStyles(styles),
    connect(mapStateToProps, mapDispatchToProps)
)(AnalyseRisquesSignatures);
